import { createFileRoute } from '@tanstack/react-router'
import { evidenceExplorerRouteKernel } from '~/features/research-workspace/route-kernels'

export const Route = createFileRoute('/$locale/research/evidence')({
  ...evidenceExplorerRouteKernel,
})
